<script>
import BaseButton from '@/components-v4/button.vue'
import LavenderMixin from '@/mixins/lavender'

export default {
  name: 'CancelDialogCommonContent',
  components: { BaseButton },
  mixins: [LavenderMixin],
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    cancelText: {
      type: String,
      required: true,
    },
    confirmText: {
      type: String,
      required: true,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onClosed() {
      this.$emit('close')
    },
    onClickedCancel() {
      this.onClosed()

      this.$emit('cancel')
    },
    onClickedConfirm() {
      this.onClosed()

      this.$emit('confirm')
    },
  },
}
</script>

<template>
  <div
    :class="
      isLavenderReskinEnabled ? 'cancel-dialog-common-content-lavender' : ''
    "
  >
    <div class="card-title-1">
      <span>{{ title }}</span>
      <v-btn
        v-if="showCloseButton && isLavenderReskinEnabled"
        fab
        small
        class="flex-grow-0 flex-shrink-0 close-btn"
        color="white"
        @click="onClickedCancel"
      >
        <SvgIcon size="20px" color="#000" name="close" />
      </v-btn>
    </div>
    <!-- This is subtitle -->
    <div class="card-subtitle-1">
      {{ message }}
    </div>
    <div class="w-full d-flex flex-column mt-9">
      <BaseButton
        class="cancel-button-dialog__cancel-btn"
        @click="onClickedCancel"
      >
        {{ cancelText }}
      </BaseButton>
      <BaseButton
        outlined
        class="mt-3 cancel-button-dialog__confirm-btn"
        @click="onClickedConfirm"
      >
        {{ confirmText }}
      </BaseButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cancel-dialog-common-content-lavender {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .card-title-1 {
    font-size: 18px;
    font-weight: 600;
    color: #16181d;
    padding: 0;
    margin-top: 0;
    margin-bottom: 24px;
    position: relative;
    text-align: center;
    width: 100%;
    .close-btn {
      position: absolute;
      background-color: #f4f6f9 !important;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .card-subtitle-1 {
    font-size: 14px;
    font-weight: 500;
    line-height: 160%;
    color: #585b7a;
  }
  .cancel-button-dialog__cancel-btn {
    background-color: #200044 !important;
    border-radius: 32px !important;
    ::v-deep(.v-btn__content) {
      color: #fff;
      font-size: 14px;
      font-weight: 600 !important;
      line-height: 24px;
      padding: 12px 16px !important;
    }
  }
  .cancel-button-dialog__confirm-btn {
    background-color: #fff;
    border-radius: 8px;
    ::v-deep(.v-btn__content) {
      color: #16181d;
      font-size: 14px;
      font-weight: 600 !important;
      line-height: 24px;
      padding: 12px 16px !important;
    }
  }
}
</style>
